/**
 * Iter-114 — Inline "Flag this item" trigger.
 *
 * Small amber-outlined AlertTriangle icon button matching the
 * existing edit/delete affordances. Opens FlagDialog on click,
 * scoped to the supplied entity_type + entity_id.
 *
 * Sizing variants:
 *   - "sm"  → 24×24 (default; sits inline next to edit pencils).
 *   - "xs"  → 20×20 (used in dense rows like SupervisorNotesList).
 *
 * Usage:
 *   <FlagButton
 *       projectId={pid}
 *       entityType="scene"
 *       entityId={sceneId}
 *       entityLabel="Scene 4"
 *   />
 */

import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import FlagDialog from "./FlagDialog";


export default function FlagButton({
    projectId,
    entityType,
    entityId,
    entityLabel,
    size = "sm",
    className = "",
    title,
    onCreated,
    testid,
}) {
    const [open, setOpen] = useState(false);
    if (!projectId || !entityType || !entityId) return null;
    const dim =
        size === "xs"
            ? "h-6 w-6"
            : size === "lg"
                ? "h-9 w-9"
                : "h-7 w-7";
    const iconSize = size === "xs" ? 11 : size === "lg" ? 15 : 13;
    return (
        <>
            <button
                type="button"
                data-testid={testid || `flag-trigger-${entityType}-${entityId}`}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setOpen(true);
                }}
                title={title || `Flag this ${entityLabel || entityType}`}
                aria-label={title || `Flag this ${entityLabel || entityType}`}
                className={`tap inline-flex items-center justify-center rounded-md ${dim} text-amber-300/80 hover:text-amber-200 border border-amber-500/30 hover:border-amber-500/60 hover:bg-amber-500/10 ${className}`}
            >
                <AlertTriangle size={iconSize} />
            </button>
            {open ? (
                <FlagDialog
                    projectId={projectId}
                    entityType={entityType}
                    entityId={entityId}
                    entityLabel={entityLabel}
                    open={open}
                    onOpenChange={setOpen}
                    onCreated={onCreated}
                />
            ) : null}
        </>
    );
}
